var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"initial"},[_c('Spinner',{attrs:{"color":"#f3aa45"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }